import { Link } from "react-router-dom";

const KelasKami = () => {
  return (
    <section className="kelasKami-container">
      <p className="homePage-title">Kelas Kami</p>
      <div className="kelasKami-contents">
        <div className="card-containerDaring">
          <div className="card-sectionTitle">
            <Link to="/PelatihanDaring">
              <p>Daring</p>
            </Link>
          </div>
        </div>

        <div className="card-containerTatapMuka">
          <div className="card-sectionTitle">
            <Link to="/PelatihanTatapMuka">
              <p>Tatap Muka</p>
            </Link>
          </div>
        </div>

        <div className="card-containerMandiri">
          <div className="card-sectionTitle">
            <Link to="/PelatihanMandiri">
              <p>Mandiri</p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KelasKami;
